import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms'
import { Router } from '@angular/router';
import { ForgetService } from './AuthService/forget.service'
import { Configuration } from '../Configuration';


@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent {
  public apptext:string
  
  constructor(private router: Router,
    private forgotService: ForgetService ,public config: Configuration) { 
      this.apptext = this.config.apptext;
    }

  model: any = {};
  forgotInvalid = false;

  ResetReq(values) {
    // this.forgotService.forget(this.model.email).subscribe(result => {
    //   if (result === true) {
          this.router.navigate(['/resetpasswordreq']);
      // } else {
      //     this.forgotInvalid = true;
      // }
    // });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/forget-password.component.ts